module.exports = __webpack_public_path__ + "static/media/feifengshan3.aa179759.webp";